module.exports = __webpack_public_path__ + "img/left - 副本.3bb6face.png";